// extracted by mini-css-extract-plugin
export default {"DialogContent":"_DialogContent--Wo70c","DialogArrow":"_DialogArrow--o50OY"};